module.exports = __webpack_public_path__ + "static/media/epdm.fabf1628.pdf";